import { render, staticRenderFns } from "./soft-stat.vue?vue&type=template&id=088c604d&scoped=true"
import script from "./soft-stat.vue?vue&type=script&lang=js"
export * from "./soft-stat.vue?vue&type=script&lang=js"
import style0 from "./soft-stat.vue?vue&type=style&index=0&id=088c604d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088c604d",
  null
  
)

export default component.exports